import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

function Gated({ children, checkEntity, checkLsp, checkProcess }) {
  const {
    isAdmin,
    id,
    entityIds,
    role,
    access = [],
  } = useSelector((state) => state.login);
  const { processdata } = useSelector((state) => state.process);
  const { id: entityId } = useParams();
  const navigate = useNavigate();

  const forbidAccessToPage = () => {
    if (id && !isAdmin && !checkEntity && !checkLsp && !checkProcess) {
      navigate("/forbidden");
    }
  };

  const forbidAccessToEntity = () => {
    if (
      id &&
      !isAdmin &&
      !checkLsp &&
      !checkProcess &&
      !checkEntity &&
      !entityIds?.includes?.(entityId)
    ) {
      navigate(`/forbidden`);
    }
  };

  const forbidAccessToProcess = () => {
    if (checkProcess && role !== "GXM_ADMIN" && processdata) {
      const entityAccess = access?.find(
        ({ entity_id }) => entity_id === processdata?.entity,
      );

      if (["LSP_USER", "LSP_MANAGER"].includes(role) && entityAccess) {
        return;
      }

      const entityTemplates = entityAccess?.process_template ?? [];

      if (!processdata?.process_template) {
        const hasServiceAccess = entityTemplates.length > 0;
        if (!hasServiceAccess) {
          navigate("/forbidden");
        }
        return;
      }

      const hasAccess = entityTemplates.includes(processdata?.process_template);
      if (!hasAccess) {
        navigate("/forbidden");
      }
    }
  };

  useEffect(() => {
    forbidAccessToProcess();
  }, [processdata]);

  useEffect(() => {
    forbidAccessToPage();
    forbidAccessToEntity();
  }, [id, isAdmin]);

  return children;
}

export default Gated;
